import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from '@astek/utils';
import {MeasureTypeEnum} from '../services/state/measure-type.enum';

@Pipe({
  name: 'xpMeasureTypeKey',
})
export class MeasureTypeKeyPipe implements PipeTransform {

  constructor() {
  }

  public transform(value: MeasureTypeEnum | string | null | undefined): string {
    if (
      Utils.isNullOrUndefined(value)
      || (Utils.isString(value) && !Utils.enumValueExists(value, MeasureTypeEnum))
    ) {
      return 'SHARED.EMPTY_VALUE';
    }
    return 'SHARED.MEASURE_TYPE.' + Utils.enumName(value, MeasureTypeEnum);
  }

}
